import { ReactNode } from 'react'
import { ThemeProvider, ThemeProviderProps } from '../../hooks/useTheme.js'
import { ToastProvider } from '../../components/Toast/index.js'
import { MediaPreviewsContextProvider } from '../../components/Media/index.js'
import { DragAndDropProvider } from '../../hooks/useDragAndDrop.js'
import { LanguageProvider } from '../../components/LanguageSelect/index.js'
import { Provider as BasedClientProvider } from '@based/sdk/react'
import {
  BasedUiEndpoints,
  BasedUiEndpointsProvider,
} from '../Endpoints/index.js'
import '@based/ui/dist/global.css'
import 'overlayscrollbars/overlayscrollbars.css'
import { BasedClient } from '@based/sdk/client'

type BasedUiProviderProps = {
  children: ReactNode
  client: BasedClient
  forcedTheme?: ThemeProviderProps['forcedTheme']
  endpoints?: BasedUiEndpoints
}

function BasedUiProvider({
  children,
  client,
  forcedTheme,
  endpoints,
}: BasedUiProviderProps) {
  return (
    <BasedClientProvider client={client}>
      <BasedUiEndpointsProvider endpoints={endpoints}>
        <ThemeProvider forcedTheme={forcedTheme}>
          <MediaPreviewsContextProvider>
            <ToastProvider>
              <LanguageProvider>
                <DragAndDropProvider>{children}</DragAndDropProvider>
              </LanguageProvider>
            </ToastProvider>
          </MediaPreviewsContextProvider>
        </ThemeProvider>
      </BasedUiEndpointsProvider>
    </BasedClientProvider>
  )
}

export type { BasedUiProviderProps }
export { BasedUiProvider }
export { BasedUiProvider as Provider }
